import { DateTime } from 'luxon'
import { z } from 'zod'

/**
 * Zod schema for UTC ISO date strings parsed into Luxon DateTime.
 *
 * Use at every external boundary where dates arrive as strings.
 * Internal code works with DateTime only; formatting happens in client/common/format.
 */
export const LuxonDateTime = z
  .string()
  .datetime({ offset: true })
  .transform((s, ctx) => {
    const dt = DateTime.fromISO(s, { zone: 'utc' })
    if (!dt.isValid) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Invalid ISO datetime: ${dt.invalidExplanation ?? 'unknown reason'}`,
      })
      return z.NEVER
    }
    return dt
  })

/**
 * Serialize a Luxon DateTime to a UTC ISO string for the wire.
 */
export const LuxonISO = (dt: DateTime): string => {
  const iso = dt.toUTC().toISO()
  if (iso === null) {
    throw new Error('Cannot serialize invalid DateTime to ISO')
  }
  return iso
}
